import React from "react";
import { Container, Heading, SubHeading,Logo,Text,InfoContainer,Line,LogoArrow,Frame,Pane} from "./styles/checkIn";

export default function CheckIn({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

CheckIn.Heading = function CheckInHeading({ children, ...restProps }) {
  return <Heading {...restProps}>{children}</Heading>;
};

CheckIn.SubHeading = function CheckInSubHeading({ children, ...restProps }) {
  return <SubHeading {...restProps}>{children}</SubHeading>;
};

CheckIn.Logo = function ClientsLogo({children, ...restProps}){
  return <Logo {...restProps} />
}

CheckIn.LogoArrow = function ClientsLogoArrow({children, ...restProps}){
  return <LogoArrow {...restProps} />
}

CheckIn.Text = function CheckInText({children, ...restProps}){
  return <Text {...restProps}>{children}</Text>
}

CheckIn.InfoContainer = function CheckInInfoContainer({children, ...restProps}){
  return <InfoContainer {...restProps}>{children}</InfoContainer>
}

CheckIn.Frame = function CheckInFrame({children, ...restProps}){
  return <Frame {...restProps}>{children}</Frame>
}

CheckIn.Pane = function CheckInPane({children, ...restProps}){
  return <Pane {...restProps}>{children}</Pane>
}

CheckIn.Line = function CheckInLine({children, ...restProps}){
  return <Line {...restProps}>{children}</Line>
}